import React from "react";
import PropTypes from "prop-types";
import { withStyles } from "@mui/styles";
import { styles } from "./styles";
import AutoComplete from "@mui/material/Autocomplete";
import _ from "lodash";
import * as dataService from "services/dataService";
import { connect } from "react-redux";
import { TextField, CircularProgress } from "@mui/material";

class PostalCodeAutoComplete extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      isLoading: false,
      isLoadingAreas: false,
      isClosing: false,
      initiate: props.update ? !props.update : true,
      resetPostalCode: props.resetPostalCode ? props.resetPostalCode : false,
      data: {
        postalCode: props.value ? props.value : null,
        postalCodeText: props.searchText ? props.searchText : "",
      },
    };
    this.onClose = this.onClose.bind(this);
    this.handleAutoCompleteChange = this.handleAutoCompleteChange.bind(this);
    this.handleOnUpdateInput = this.handleOnUpdateInput.bind(this);
    this.getUpdatedPostalCodeList = _.debounce(
      this.getUpdatedPostalCodeList.bind(this),
      500,
    );
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.resetPostalCode && !this.state.resetPostalCode) {
      this.setState({
        resetPostalCode: false,
        data: {
          postalCode: null,
          postalCodeText: ""
        },
      });
      this.props.onPostalCodeReset();
    }
    if (
      !this.state.initiate &&
      (nextProps.value &&
      nextProps.searchText) &&
      nextProps.update
    ) {
      this.setState({
        initiate: true,
        data: {
          postalCode: nextProps.value,
          postalCodeText: nextProps.searchText,
        },
      });
    }
  }

  onClose() {
    if (this.state.isLoading) {
      this.setState({ isClosing: true });
    } else {
      this.setState({ isClosing: false });
      if (!this.state.data.postalCode) {
        const { data } = this.state;
        data["postalCode"] = "";
        this.setState({ data });
      }
    }
  }

  handleOnUpdateInput(searchText) {
    const trimmedSearchText = searchText.trimRight();
    const { data } = this.state;

    const parts = searchText.split(',');
    const firstPart = parts[0].trim();

    if(data.postalCodeText == firstPart) return


    data.postalCodeText = firstPart;
    this.setState({ data });


    // Clear results if input is empty
    if (firstPart.length === 0) {
      data.postalCode = null;
      this.props.updatePostalCodeObject(null);
      this.setState({ data });
      return;
    }

    if (firstPart.length >= 2 && this.props.filter_by_country) {
      this.getUpdatedPostalCodeList(firstPart);
    }
  }


  handleAutoCompleteChange = (event,newValue) => {
    const { data } = this.state;
    data["postalCode"] = newValue ? newValue : null;
    data["postalCodeText"] = newValue ? newValue.postalCode : "";
    this.setState({ data, isLoading: false });
    
    if (newValue && this.props.hasPostalCode) {
      this.setState({ isLoadingAreas: true });
      const input = [
        { key: "name", element: newValue.city },
        { key: "country_id", element: this.props.filter_by_country },
        { key: "from_dhl_postal", element: true }
      ];
      
      this.props.dispatch(dataService.fetchAutoCompleteAreas(input))
        .then(response => {
          this.setState({ isLoadingAreas: false });
          if (response && response.data && response.data.length > 0) {
            this.props.updatePostalCodeObject(newValue, true, response.data[0]);
          } else {
            this.props.updatePostalCodeObject(newValue, true, null);
          }
        })
        .catch(error => {
          this.setState({ isLoadingAreas: false });
          this.props.updatePostalCodeObject(newValue, true, null);
        });
    } else {
      this.props.updatePostalCodeObject(newValue, true, null);
    }
  };
  // Modified debounced API call function
  getUpdatedPostalCodeList = _.debounce((searchText) => {
    if (this.state.data.postalCode) {
      return;
    }
    
    this.setState({ isLoading: true });

    const input = { 'postalCode': searchText, 'country' : this.props.filter_by_country };

    this.props
      .dispatch(dataService.fetchPostalCodeAddress(input))
      .then((response) => {
        this.setState({ isLoading: false });
      })
      .catch((error) => {
        this.setState({ isLoading: false });
      });
  }, 500);


  render() {
    const {
        postalCodeAddressList,
        floatingLabelText,
        errorText,
        fullWidth,
    } = this.props;

    return (
      <AutoComplete
        aria-label={floatingLabelText}
        value={this.state.data.postalCode}
        inputValue={this.state.data.postalCodeText}
        filterOptions={(options) => options}
        onChange={this.handleAutoCompleteChange}
        onInputChange={(event, newInputValue) => this.handleOnUpdateInput(newInputValue, postalCodeAddressList)}
        openOnFocus
        fullWidth={fullWidth}
        options={postalCodeAddressList}
        getOptionLabel={(option) => option.postalCodeCity || ""}
        getOptionKey={(option) => option.postalCodeCity || ""}
        isOptionEqualToValue={(option, value) => option.postalCodeCity === value.postalCodeCity}
        onClose={this.onClose}
        renderInput={(params) => (
          <TextField
            {...params}
            label={floatingLabelText}
            error={!!errorText}
            helperText={
              this.state.isLoading ? "Searching postal codes..." :
              this.state.isLoadingAreas ? "Loading area information..." :
              errorText
            }
            variant="standard"
            InputProps={{
              ...params.InputProps,
              endAdornment: (this.state.isLoading || this.state.isLoadingAreas) ? (
                <CircularProgress size={20} />
              ) : null,
             }}
            style={{ maxHeight: "200px" }}
          />
        )}
      />
    );
  }
}

PostalCodeAutoComplete.propTypes = {
  floatingLabelText: PropTypes.string.isRequired,
  classes: PropTypes.object.isRequired,
  fullWidth: PropTypes.bool,
  errorText: PropTypes.any,
  value: PropTypes.any,
  searchText: PropTypes.any,
  postalCodeAddressList : PropTypes.array.isRequired,
  update: PropTypes.bool,
  hasPostalCode: PropTypes.bool,
};

const mapStateToProps = (state) => {
  return {
    postalCodeAddressList: state.data.postalCodeAddressList,
  };
};

export default withStyles(styles)(
  connect(mapStateToProps)(PostalCodeAutoComplete)
);
